import { useDocumentMeta } from "../hooks/useDocumentMeta";
import { LegalLayout } from "../components/LegalLayout";

export default function MentionsLegales() {
  useDocumentMeta({
    title: "Mentions légales — FOD by DMB Partners",
    description: "Mentions légales de FOD by DMB Partners : identité de l'éditeur du site, hébergeur, directeur de la publication et coordonnées légales.",
    canonical: "https://www.fodbydmb.com/mentions-legales",
  });
  return (
    <LegalLayout testid="mentions-page" title="Mentions légales">
          <p>
            Le présent site web est édité par <strong>DMB PARTNERS</strong>, société par actions simplifiée
            au capital social de 1 000 euros, dont le siège social est sis 149 avenue du Maine, 75014 Paris,
            France, immatriculée au Registre du Commerce et des Sociétés de Paris sous le numéro 928 053 487.
          </p>
          <p>
            Email : <a href="mailto:contact@fodbydmb.com">contact@fodbydmb.com</a>
          </p>
          <p>Le directeur de la publication du présent site web est : Hugo DAUGERON-MIJOIN.</p>
          <h3>Hébergement</h3>
          <p>
            Le présent site web est hébergé par <strong>Emergent Labs Inc.</strong>, 2380 Via Espada, Pleasanton,
            CA 94566, États-Unis. Contact : <a href="mailto:support@emergent.sh">support@emergent.sh</a>.
          </p>
          <h3>Conception</h3>
          <p>Conception et création graphique : CYANEA GRAPHISME.</p>
    </LegalLayout>
  );
}
